'use strict';

import React from 'react';
import PropTypes from 'prop-types';

export default class CountryInputField extends React.Component {
  static propTypes = {
    data: PropTypes.shape({
      shortName: PropTypes.string,
      longName: PropTypes.string,
    }).isRequired,
    updater: PropTypes.object.isRequired,
    shortName: PropTypes.string.isRequired,
    longName: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
    };
  }

  componentDidMount() {
    this.props.updater.addListener('Country.set', this.listener);
  }

  componentWillUnmount() {
    this.props.updater.removeListener('Country.set');
  }

  listener = (data) => {
    this.setState({
      data: { shortName: data.short_name, longName: data.long_name },
    });
  }

  render() {
    return (
      <div>
        <input
          type="hidden"
          value={this.state.data.shortName}
          name={this.props.shortName} />
        <input
          readOnly={true}
          className="form-control"
          type="text"
          name={this.props.longName}
          value={this.state.data.longName} />
      </div>
    );
  }
}
